// extracted by mini-css-extract-plugin
export default {"BasicEditor":"BasicEditor--BajmY","hasError":"hasError--7LPew"};